import { postFetch, getFetch } from '@/utils/request'

export function getCartListData() {
    return getFetch('/shoppingCart/getCartGoodsList', {});
}

export function settleCheckData(cartIds) {
    return postFetch('/shoppingCart/settleCheck', null, {ids: cartIds});
}

export function cancelSettleCheckkData(cartIds) {
    return postFetch('/shoppingCart/cancelSettleCheck', null, {ids: cartIds});
}

export function addCartGoodsData(mallGoodsWarehouseId, num) {
    return postFetch('/shoppingCart/addCartGoods', null, {mallGoodsWarehouseId: mallGoodsWarehouseId, num: num});
}

export function modifyCartGoodsData(cartId, num) {
    return postFetch('/shoppingCart/modifyCartGoods', null, {cartId: cartId, num: num});
}

export function removeGoodsData(cartIds) {
    return postFetch('/shoppingCart/removeGoods', null, {ids: cartIds});
}

export function clearCartGoodsData(accountId) {
    return getFetch('/shoppingCart/clearCartGoods', {accountId: accountId});
}

export function countCartGoodsData() {
    return getFetch('/shoppingCart/countCartGoods', {});
}


// WEBPACK FOOTER //
// ./src/api/cartApi.js